import { withI18n } from 'react-i18next';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

/* Redux content */
import {
  productsSel,
  filtersSel,
  categoriesPendingSel,
  subcategoriesPendingSel,
  productsPendingSel,
  subcategoriesFiltersPendingSel,
  failedSel,
  errorSel,
  categoriesActions,
  activeFiltersSel,
  subcategoriesSel,
  filteredProductsSel
} from 'src/store/modules/categories';

import { showOnlyMsrpSel } from 'src/store/modules/msrp';

import {
  pageSizeSel,
  pageNumberSel,
  totalElementsSel,
  totalPagesSel
} from 'src/store/modules/pagination';

import { activeAccountSel } from 'src/store/modules/signin';

import Categories from './Categories';
import SubcategoryFilter from 'src/model/subcategoryFilter.model';
import SubcategoryBrandFilter from 'src/model/subcategoryBrandFilter.model';

const mapStateToProps = (state: any) => {
  return {
    onlyMSRP: showOnlyMsrpSel(state),
    subcategories: subcategoriesSel(state),
    products: productsSel(state),
    filters: filtersSel(state),
    brands: state.categories.brands,
    activeFilters: activeFiltersSel(state),
    getSubcategoriesIsPending: subcategoriesPendingSel(state),
    getCategoriesIsPending: categoriesPendingSel(state),
    getProductsIsPending: productsPendingSel(state),
    getSubcategoriesFilterIsPending: subcategoriesFiltersPendingSel(state),
    apiFailed: failedSel(state),
    error: errorSel(state),
    activeAccount: activeAccountSel(state),
    filteredProducts: filteredProductsSel(state),
    paginator: {
      pageSize: pageSizeSel(state),
      pageNumber: pageNumberSel(state),
      totalElements: totalElementsSel(state),
      totalPages: totalPagesSel(state)
    }
  };
};

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  getProductsBySubCategory: (
    subcategoryId: string,
    activeAccount: string,
    pageNumber: number,
    pageSize: number
  ) =>
    dispatch(
      categoriesActions.getProductsByCategory(
        subcategoryId,
        '',
        activeAccount,
        pageNumber,
        pageSize
      )
    ),
  getCategories: (categoryId: string) =>
    dispatch(categoriesActions.getSubcategories(categoryId)),
  getSubcategoriesFilters: (subcategoryId: string) =>
    dispatch(categoriesActions.getFiltersBySubcategory(subcategoryId)),
  setActiveFilters: (filters: SubcategoryFilter[]) =>
    dispatch(categoriesActions.setActiveFilters(filters)),

  getSubcategoriesBrands: (subcategoryId: string) =>
    dispatch(categoriesActions.getBrandsBySubcategory(subcategoryId)),
  setActiveBrands: (brands: SubcategoryBrandFilter[]) =>
    dispatch(categoriesActions.setActiveBrands(brands)),
  
  getFilteredProducts: (
    id: string,
    filters: SubcategoryFilter[],
    selectionType: string,
    pageNumber: number,
    pageSize: number
  ) =>
    dispatch(
      categoriesActions.getFilteredProducts(id, filters,selectionType, pageNumber, pageSize)
    )
});

export const pureComponent = Categories;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(withRouter(Categories)));

interface IDispatchFromProps {
  getProductsBySubCategory(
    subcategoryId: string,
    activeAccount: string,
    pageNumber: number,
    pageSize?: number
  ): void;
  getCategories(categoryId: string): void;
  getSubcategoriesFilters(subcategoryId: string): any;
  getSubcategoriesBrands(subcategoryId: string): any;
  setActiveFilters(filters: SubcategoryFilter[]): void;
  setActiveBrands(brands: SubcategoryBrandFilter[]): void;
  getFilteredProducts(
    id: string,
    filters: SubcategoryFilter[],
    selectionType: string,
    pageNumber?: number,
    pageSize?: number
  ): any;
}
